import axios from "axios";

export const adminCreateCategoryApi = async (token, categoryData, signal) => {
  // post request to the server to create a new category
  // token (String): bearer token used for authentication
  // categoryData (JSON): the data for the new category { name (String), description (String), _id (String), parent (String) }
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/categories`, categoryData, config, {
      signal,
    });
    return data;
  } catch (error) {
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const adminAddCategoryImageApi = async (token, id, newImage) => {
  // post request to the server to add/update a new image for the category
  // token (String): bearer token used for authentication
  // id (String): the id of the category to be updated
  // newImage (JSON): object with url (String) and public_id (String)
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/categories/images/${id}`,
      newImage,
      config
    );
    return data;
  } catch (error) {
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const adminUpdateCategoryApi = async (token, categoryData, signal) => {
  // post request to the server to update a category
  // token (String): bearer token used for authentication
  // categoryData (JSON): the data for the new category { name (String), description (String), _id (String), parent (String) }
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/categories/${categoryData._id}`,
      categoryData,
      config,
      { signal }
    );
    return data;
  } catch (error) {
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const adminDeleteCategoryApi = async (token, categoryId, signal) => {
  // delete request to the server to delete a category
  // token (String): bearer token used for authentication
  // categoryId: the id of the category to be deleted
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/categories/${categoryId}`,
      config,
      { signal }
    );
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const fetchCategoriesApi = async (signal) => {
  // get request to the server to retrieve all available categories
  //returns an array of jsons with representing the category tree (category data + children, ...)
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`, { signal });
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};


export const fetchMainCategoriesApi = async (signal) => {
  // get request to the server to retrieve main categories only
  //returns an array of jsons with the main categories
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories/main`, { signal });
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};
